import React from 'react';
import BeaconDropdownMetricColumnChart from 'src/components/BeaconV2Components/BeaconMetricColumnChart/BeaconDropdownMetricColumnChart';
import { useMainEntityType } from 'src/utils/Hooks/reduxSelectors';
import TopEntityChartV2Loading from 'src/components/BeaconV2Components/TopEntityChartV2/TopEntityChartV2Loading';

export const ContentScoreUtilizationBar = () => {
  const entityType = useMainEntityType();

  return (
    <BeaconDropdownMetricColumnChart
      beaconChartWithLegendPropsBuilder={(props) => ({
        ...props,
        loadingComponent: <TopEntityChartV2Loading />
      })}
      indexName="new-content-metrics"
      fieldName="contentScore"
      dropdownOptions={[
        {
          id: 'categoryId',
          label: 'Category'
        },

        {
          id: 'subCategoryId',
          label: 'Subcategory'
        },
        {
          id: 'brandId',
          label: 'Brand'
        }
      ].filter((option) => !option.id.toLowerCase().startsWith(entityType))}
      titlePrefix="Content Utilization by"
    />
  );
};
